export const getFileNameWithoutExtension = (fullFileName) => {
    const lastDotIndex = fullFileName.lastIndexOf('.');

    if (lastDotIndex === -1) return fullFileName; // No extension found

    return fullFileName.substring(0, lastDotIndex);
}